var _defs, _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTooth02(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100.44 152.52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n\n      .cls-1, .cls-2 {\n        stroke: #000;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n      }\n\n      .cls-2 {\n        fill: none;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m44.89,10.74s7.03-9.37,9.37-4.69c2.34,4.69,2.34,14.06,2.34,14.06,0,0,0,16.4,2.34,18.75,2.34,2.34,2.34,4.69,2.34,4.69,0,0,2.34,7.03-2.34,9.37s-9.37,9.37-11.72,4.69c-2.34-4.69-7.03-30.46-4.69-37.5,2.34-7.03,2.34-9.37,2.34-9.37Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m28.49,8.39s7.03-7.03,11.72-7.03c0,0,7.03-2.34,4.69,9.37-2.34,11.72-2.34,39.84,2.34,44.53,4.69,4.69,9.37,2.34,11.72-4.69,2.34-7.03,7.03-30.46,7.03-35.15s2.34-11.72,7.03-11.72,11.72,4.69,14.06,21.09c2.34,16.4,2.34,46.87,2.34,51.56s0,9.37,2.34,14.06,9.37,14.06,7.03,32.81c-2.34,18.75-4.69,28.12-18.75,28.12s-23.43-4.69-25.78-4.69-4.69,2.34-11.72,2.34-32.81,7.03-37.5-9.37S.37,111.51,2.71,104.47c2.34-7.03,7.03-39.84,9.37-56.24C14.43,31.83,23.8,15.42,28.49,8.39Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m22.4,129.55s19.18,3.84,29.41-6.39"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m49.25,138.5s0-7.67,7.67-7.67,15.34,2.56,20.46,2.56"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m21.12,82.23s35.49-10.57,63.93,2.56"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTooth02);
export default __webpack_public_path__ + "static/media/tooth-02.6b0da3e4ba21613101ceeb47aa8080c1.svg";
export { ForwardRef as ReactComponent };